module.exports = __webpack_public_path__ + "media/playing_full_house_4.1bf84cab.mp3";